module.exports = "https://cdn.thelire.com/ins/resource/cg_tab5_shop@3x.c7b39ec5f3131f6774555c731b68df19.png";